import { Axios } from 'utils/AxiosConfig'

export const postCalculateValuationTools = async (payload) => {
   const { data: response } = await Axios.post(`member/paid-service/calculate`, payload)
   return response
}
export const postValuationToolsPaid = async (payload) => {
   const { data: response } = await Axios.post(`member/paid-service`, payload)
   return response
}